class CartFreeShipping extends HTMLElement {
  constructor() {
    super();

    this.cartTotal = parseInt(this.getAttribute('cart-total'))
    this.thresholdAmounts = {
        UK: '6900',
        US: '15000',
        EU: '9000',
        AUS: '22000',
        ROW: '0'
    };

    // Set the threshold amount based on user location
    this.userCountry = this.getUserLocation();
    this.thresholdAmount = this.thresholdAmounts[this.userCountry] || this.thresholdAmounts.ROW; // Default to ROW if location is not found

    this.thresholdAmountFormatted = `${Shopify.formatMoney(this.thresholdAmount - this.cartTotal)}`.replace(' ','');
    this.percentage = Math.min((this.cartTotal / this.thresholdAmount) * 100, 100);

  }

  // Function to determine user location
  getUserLocation() {
      const userCountry = window.Shopify.country || 'ROW';
      switch (userCountry) {
        case 'GB':
        case 'GG':
        case 'IM':
        case 'JE':
          return 'UK';
        case 'US':
          return 'US';
        case 'AU':
          return 'AUS';
          case 'FR':
          case 'DE':
          case 'IT':
          case 'ES':
          case 'NL':
          case 'BE':
          case 'AT':
          case 'IE':
          case 'PT':
          case 'GR':
          case 'FI':
          case 'SE':
          case 'DK':
          case 'PL':
          case 'CZ':
          case 'HU':
          case 'RO':
          case 'BG':
          case 'HR':
          case 'SI':
          case 'SK':
          case 'EE':
          case 'LV':
          case 'LT':
          case 'CY':
          case 'MT':
          case 'LU':
            return 'EU';
          default:
            return 'ROW';
      }
    }

  connectedCallback() {
      if (!['ROW'].includes(this.userCountry)) {
        //console.log(`${this.cartTotal} >= ${this.thresholdAmount}`)
        //console.log(this.thresholdAmountFormatted);
        if (this.cartTotal >= this.thresholdAmount) {
          this.innerHTML = `<p class="free-shipping-notification__title">🎉 Woohoo!</p>
              <p class="free-shipping-notification__message">You've qualified for <strong>free delivery!</strong></p>
          `;
        } else if (this.cartTotal > 0) {
          this.innerHTML = `
              <p class="free-shipping-notification__title">📦 Get free delivery!</p>
              <p class="free-shipping-notification__message">You're only <strong>${this.thresholdAmountFormatted}</strong> away from <strong>free delivery!</strong></p>
                <div class="free-shipping-notification__threshold">
                    <div class="free-shipping-notification__threshold__bar" style="width: ${this.percentage}%"></div>
              </div>
          `;
        }
    }
  }

  disconnectedCallback() {
  }

  adoptedCallback() {
  }

  attributeChangedCallback(name, oldValue, newValue) {
  }


}

document.addEventListener("DOMContentLoaded", (event) => {
    customElements.define('free-shipping-notification', CartFreeShipping);
});
